import { useCallback, useRef, useState } from "react";

/**
 * Custom hook to manage the guard submission states.
 * to prevents multiple submissions
 */
export const useSubmitting = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  const wrap = useCallback(async (fn: () => Promise<void>) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    try {
      await fn();
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  }, []);

  return { isSubmitting, wrap };
};
